export const RouteMap = {
  HOME_ROUTE: '/',
  MONITORING_ROUTE: '/datenmonitoring',
  UPLOAD_ROUTE: '/datenmonitoring/datenimport',
  FILE_DETAIL_ROUTE: '/datenmonitoring/datenimport/:importoperationid',
  MEASUREMENT_VISUALIZATION: '/datenmonitoring/messwertvisualisierung',
  MEASUREMENT_EXPORT: '/datenmonitoring/messwertexport',
  IMPORTED_MEASUREMENTS_OVERVIEW: '/datenmonitoring/messwertuebersicht',
  ANALYSES_ROUTE: '/analysen',
  PQ_INDEX: 'analysen/pq-index',
  HARMONIC_BACKGROUND_LEVEL: 'analysen/harmonischerhintergrundpegel',
  CORRELATION: 'analysen/korrelationsanalyse',
  TREND: 'analysen/trendidentifikation',
  ADMIN_ROUTE: '/administration',
  ADMINISTRATION_ROUTE: '/administration/messpunktverwaltung',
  MASTERDATA_ADMINISTRATION_ROUTE: '/administration/stammdatenverwaltung',
};
